export class AuditLogEntitiesInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "string",
            "format": ""
        },
        {
            "name": "entityId",
            "baseName": "entityId",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuditLogEntitiesInner.attributeTypeMap;
    }
    constructor() {
    }
}
